var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryWebDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 15H3.33301M3.33301 13L3.33301 27C3.33301 29.8003 3.33301 31.2004 3.87798 32.2699C4.35734 33.2108 5.12224 33.9757 6.06306 34.455C7.13261 35 8.53274 35 11.333 35H28.6663C31.4666 35 32.8667 35 33.9363 34.455C34.8771 33.9757 35.642 33.2108 36.1214 32.27C36.6663 31.2004 36.6663 29.8003 36.6663 27V13C36.6663 10.1997 36.6663 8.79961 36.1214 7.73005C35.642 6.78924 34.8771 6.02434 33.9363 5.54497C32.8667 5 31.4666 5 28.6663 5L11.333 5C8.53275 5 7.13262 5 6.06306 5.54497C5.12225 6.02433 4.35734 6.78924 3.87798 7.73005C3.33301 8.79961 3.33301 10.1997 3.33301 13Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryWebDevelopment);
export default __webpack_public_path__ + "react/media/category-web_development.6ed3f8eebc896e83c0fb7215c47a78af.svg";
export { ForwardRef as ReactComponent };